import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Clave", value: true },
    { title: "Código de Unidad", value: true },
    { title: "Sucursal", value: true },
    { title: "Tipo de Unidad", value: true },
    { title: "Placa Vehicular", value: true },
    { title: "Año del Modelo", value: true },
    { title: "Permiso SCT", value: true },
    { title: "N° de Permiso SCT", value: true },
];

class TransporteView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            total: 0,
            documentTypeSeries: [],
            series: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
        }
    }

    async componentDidMount(filter) {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liTransportes");
        await this.callDocumentsListService(filter);
        await this.getSeries();
    }
    getSeries = async () => {
        const { enableSpinner } = this.props;
        let dataSerie = {
            docType: '',
            docSubType: ''
        };
        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);
        this.setState({
            series: seriesResponse.data || [],
        })
    }
    searchTransportes = async filter => {
        await this.callDocumentsListService(filter);
    };

    callDocumentsListService = async (filter = { priceValue: '---', groupCodeValue: '---', employeeValue: '---' }) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let transporteResponse = await apiClient.getTransporteList(filter);

        if (transporteResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: transporteResponse.data.manager,
                total: transporteResponse.data.totalRows
            });

        }
        enableSpinner(false);
    };

    SetInitialSeries = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props
        enableSpinner(true);
        const responseApi = await apiClient.listDocTypeSeries();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return
        }

        if (responseApi.data.length === 0) {
            showAlert({ type: 'info', message: `No hay información de series y correlativos de esta sucursal comunícate con FMB Solutions` });
            return
        }
        await this.setState({
            documentTypeSeries: responseApi?.data ?? [],
        })
    }

    NameProperty = (property = null) => {
        let name = "";
        switch (property) {
            case 'invoice':
                name = "U_FMB_ValidateSeriesOINV";
                break;
            case 'DownPayments':
                name = "U_FMB_ValidateSeriesODPI";
                break;
            case 'PurchaseDownPayments':
                name = "U_FMB_ValidateSeriesODPO";
                break;
            case 'quotations':
                name = "U_FMB_ValidateSeriesOQUT";
                break;
            case 'orderSales':
                name = "U_FMB_ValidateSeriesORDR";
                break;
            case 'deliveries':
                name = "U_FMB_ValidateSeriesODLN";
                break;
            case 'return':
                name = "U_FMB_ValidateSeriesORDN";
                break;
            case 'payment':
                name = "U_FMB_ValidateSeriesORCT";
                break;
            case 'transfers':
                name = "U_FMB_ValidateSeriesOWTR";
                break;
            case 'debitNote':
                name = "U_FMB_ValidateSeriesDN";
                break;
            case 'creditNote':
                name = "U_FMB_ValidateSeriesORIN";
                break;
            case 'transfersRequest':
                name = "U_FMB_ValidateSeriesOWTQ";
                break;
            case 'transfersEntry':
                name = "U_FMB_ValidateSeriesOIGN";
                break;
            case 'transfersOutput':
                name = "U_FMB_ValidateSeriesOIGE";
                break;
            case 'PurchaseOrder':
                name = "U_FMB_ValidateSeriesOPOR";
                break;
            case 'PurchaseRequest':
                name = "U_FMB_ValidateSeriesOPRQ";
                break;
            case 'purchaseReturn':
                name = "U_FMB_ValidateSeriesORPD";
                break;
            case 'inventoryRevaluation':
                name = "U_FMB_ValidateSeriesOMRV";
                break;
            case 'GoodsReceipt':
                name = "U_FMB_ValidateSeriesOPDN";
                break;
            case 'outgoingPayment':
                name = "U_FMB_ValidateSeriesOVPM";
                break;
            case 'purchaseQuotation':
                name = "U_FMB_ValidateSeriesOPQT";
                break;
            case 'purchaseInvoice':
                name = "U_FMB_ValidateSeriesOPCH";
                break;
            case 'purchaseCreditNotes':
                name = "U_FMB_ValidateSeriesORPC";
                break;
            case 'purchaseDebitNotes':
                name = "U_FMB_ValidateSeriesDM";
                break;
            case 'LandedCosts':
                name = "U_FMB_ValidateSeriesOIPF";
                break;
            case 'ProductionOrder':
                name = "U_FMB_ValidateSeriesOWOR";
                break;
            case 'InventoryGenExits':
                name = "U_FMB_SeriesInventoryGenExits";
                break;
            case 'InventoryGenEntries':
                name = "U_FMB_SeriesInventoryGenEntries";
                break;
            case 'Sugerido':
                name = "U_FMB_SeriesSugerido";
                break;
            case 'InventoryCounting':
                name = "U_FMB_ValidateSeriesOINC";
                break;
            case 'InventoryPosting':
                name = "U_FMB_ValidateSeriesOIQR";
                break;
            case 'PurchaseQuotation':
                name = "U_FMB_ValidateSeriesOPQT";
                break;
            case 'SERIES':
                name = "U_FMB_ValidateSeriesSUNAT";
                break;
            default:
                name = "";
        }

        return { name }
    };
    render() {
        const { headers, data, total, documentTypeSeries, series,_user } = this.state;
        const itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        return (
            <div className="content">
                <NavBar props={this.props}  _user={_user} itemsDashboard={itemsDashboard} />
                <TimeOut />
                <BreadCumb subitem1={'TRANSPORTES'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <label id="liTransportes" className="text-muted">
                            &nbsp;TRANSPORTES
                        </label>
                    </h2>
                    <DataTables 
                        headers={headers}
                        view={"transports"}
                        data={data}
                        search={this.searchTransportes}
                        totalRows={total}
                        SetInitialSeries={this.SetInitialSeries}
                        documentTypeSeries={documentTypeSeries}
                        NameProperty={this.NameProperty}
                        series={series} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransporteView);